import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _IfThenElseModel;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { GuidedExpressionEditor } from "abreact/expression/ui/editor/GuidedExpressionEditor";
import { IfThenElseOperandValueModel } from "abreact/expression/ui/editor/impl/model/impl/conditional/IfThenElseOperandValueModel";
import { OperatorOperandValueImpl } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/OperatorOperandValueImpl";
import { action, makeObservable, observable } from "mobx";
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;
// import ValidatedExpOperator = Expression.Domain.ValidatedExpOperator;

export let OperandName = /*#__PURE__*/function (OperandName) {
  OperandName["IF"] = "if";
  OperandName["THEN"] = "then";
  OperandName["ELSE"] = "else";
  return OperandName;
}({});
export let IfThenElseModel = (_dec = observable.shallow, _dec2 = observable.ref, _class = (_IfThenElseModel = class IfThenElseModel {
  constructor(ifThenElseOperatorOperandValue, expressionDomainModel) {
    _initializerDefineProperty(this, "_modelList", _descriptor, this);
    _initializerDefineProperty(this, "_rootIfThenElseOperatorOperandValue", _descriptor2, this);
    _defineProperty(this, "_valueTypeID", void 0);
    _defineProperty(this, "_expressionDomainModel", void 0);
    this._expressionDomainModel = expressionDomainModel;
    this.init(ifThenElseOperatorOperandValue);
    makeObservable(this);
  }
  static create(ifThenElseOperatorOperandValue, expressionDomainModel) {
    return new IfThenElseModel(ifThenElseOperatorOperandValue, expressionDomainModel);
  }
  static createEmpty(expOperator, id, expressionDomainModel) {
    let ifThenElseOperatorOperandValue = new OperatorOperandValueImpl({
      id: id,
      ...GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue.partialStateFromExpOperator(expOperator, expressionDomainModel)
    });
    return new IfThenElseModel(ifThenElseOperatorOperandValue, expressionDomainModel);
  }
  get valueTypeID() {
    return this._valueTypeID;
  }
  get rootIfThenElseOperatorOperandValue() {
    return this._rootIfThenElseOperatorOperandValue;
  }
  get modelList() {
    return this._modelList;
  }
  init(ifThenElseOperatorOperandValue) {
    this._modelList = [];
    this._valueTypeID = ifThenElseOperatorOperandValue.expOperator.output.valueTypeID;
    const topModel = IfThenElseOperandValueModel.create(ifThenElseOperatorOperandValue, this._expressionDomainModel);
    this._modelList.push(topModel);
    topModel.position = this._modelList.indexOf(topModel);
    this.addElements(topModel);
    this.updateRootOperatorOperandValue();
  }
  updateRootOperatorOperandValue() {
    this._rootIfThenElseOperatorOperandValue = this._modelList[0].ifThenElseOperatorOperandValue;
  }
  addElements(model) {
    if (model.elseIsNextIf) {
      const newModel = IfThenElseOperandValueModel.create(model.elseOperandValue, this._expressionDomainModel, model);
      this._modelList.push(newModel);
      newModel.position = this._modelList.indexOf(newModel);
      this.addElements(newModel);
    }
  }
  isTopIf(operandValueModel) {
    return this._modelList.indexOf(operandValueModel) === 0;
  }
  isElse(operandValueModel) {
    return this._modelList.length - 1 === this._modelList.indexOf(operandValueModel);
  }
  deleteModel(deletedModel) {
    this._modelList.splice(this.modelList.indexOf(deletedModel), 1);
    if (deletedModel.parentModel) {
      this.setOperandValue(deletedModel.parentModel, OperandName.ELSE, undefined);
    } else {
      this.reset();
    }
  }
  addModel(after, id) {
    const newModel = IfThenElseOperandValueModel.createEmpty(this.rootIfThenElseOperatorOperandValue.expOperator, id, this._expressionDomainModel, after);
    this._modelList.splice(this.modelList.indexOf(after) + 1, 0, newModel);
    this.reset();
  }
  reset() {
    let currentParent = undefined;
    for (let model of this._modelList) {
      model.setParent(currentParent);
      model.position = this._modelList.indexOf(model);
      currentParent = model;
    }
    if (this.modelList.length > 1) {
      let bottomModel = this.modelList[this.modelList.length - 1];
      bottomModel.updateParent();
    }
    this.updateRootOperatorOperandValue();
  }
  setOperandValue(model, operandName, operandValue) {
    model.setOperandValue(operandName, operandValue);
    this.reset();
  }
}, _defineProperty(_IfThenElseModel, "ADDITIONAL_DATA_MARKING_TYPE", "non-boolean-if-then-else"), _IfThenElseModel), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_modelList", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_rootIfThenElseOperatorOperandValue", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "init", [action], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateRootOperatorOperandValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateRootOperatorOperandValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteModel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addModel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOperandValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOperandValue"), _class.prototype), _class);
//# sourceMappingURL=IfThenElseModel.js.map
